import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import {
  ApplicationControlModule,
  ApplicationControlRuleAction,
  ApplicationControlRuleTargetsType,
  ApplicationControlTargetContext,
  ApplicationControlTargetProcessType,
} from '@nirvana/shared/dtos/types/policies/common';
import { ApplicationControlSearchableKeywords } from './application-control.types';
import { ColumnValue } from '../../../../../../grid/types/common';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';
import { EnumListItem } from '../../../../../../ui/gzEnumList/types';
import { IColumnOption } from '../../../../../../ui/gzDataTable/types';

export const APPLICATION_CONTROL_DEFAULT_VALUE: ApplicationControlModule = {
  general: {
    enable: true,
    reportOnly: false,
  },
  startRules: [],
};

// searchable keywords
export function getApplicationControlSearchableKeywords(): {
  [type in ApplicationControlSearchableKeywords]: SearchableKeyword;
} {
  return {
    [ApplicationControlSearchableKeywords.ApplicationControl]: {
      translatedLabel: translateFn('Application Control'),
      label: 'Application Control',
    },
    [ApplicationControlSearchableKeywords.TestMode]: {
      translatedLabel: translateFn('Test Mode'),
      label: 'Test Mode',
    },
    [ApplicationControlSearchableKeywords.RunInTestMode]: {
      translatedLabel: translateFn('Run in Test Mode'),
      label: 'Run in Test Mode',
    },
    [ApplicationControlSearchableKeywords.ProcessStartRules]: {
      translatedLabel: translateFn('Process Start Rules'),
      label: 'Process Start Rules',
    },
  };
}

// Status section
export enum ApplicationControlRuleItemStatus {
  ENABLED = 1,
  DISABLED = 0,
}
export function getApplicationControlItemStatusGridValues(): Array<ColumnValue> {
  return [
    {
      label: translateFn('Enabled'),
      value: ApplicationControlRuleItemStatus.ENABLED,
    },
    {
      label: translateFn('Disabled'),
      value: ApplicationControlRuleItemStatus.DISABLED,
    },
  ];
}

// Permission section
function getLabelByRuleItemAction(action: ApplicationControlRuleAction): string {
  switch (action) {
    case ApplicationControlRuleAction.ALLOW:
      return translateFn('Allow');
    case ApplicationControlRuleAction.BLOCK:
      return translateFn('Deny');
  }
}
export function getApplicationControlItemActionsGridValues(): Array<ColumnValue> {
  return [
    {
      label: getLabelByRuleItemAction(ApplicationControlRuleAction.ALLOW),
      value: ApplicationControlRuleAction.ALLOW,
    },
    {
      label: getLabelByRuleItemAction(ApplicationControlRuleAction.BLOCK),
      value: ApplicationControlRuleAction.BLOCK,
    },
  ];
}
export function getApplicationControlItemActionsFormOptions(): Array<SelectOption> {
  return [
    {
      title: getLabelByRuleItemAction(ApplicationControlRuleAction.ALLOW),
      value: ApplicationControlRuleAction.ALLOW,
    },
    {
      title: getLabelByRuleItemAction(ApplicationControlRuleAction.BLOCK),
      value: ApplicationControlRuleAction.BLOCK,
    },
  ];
}

// Target type section
export function getTargetTypeFormOptions(): Array<SelectOption> {
  return [
    {
      title: translateFn('Specific process or processes'),
      value: ApplicationControlRuleTargetsType.SPECIFIC_PROCESSES,
    },
    {
      title: translateFn('Inventory applications or groups'),
      value: ApplicationControlRuleTargetsType.APPLICATIONS_INVENTORY,
    },
  ];
}

// Target process type section
function getTargetProcessTypeLabel(type: ApplicationControlTargetProcessType): string {
  switch (type) {
    case ApplicationControlTargetProcessType.PATH:
      return translateFn('Path');
    case ApplicationControlTargetProcessType.HASH:
      return translateFn('Hash');
    case ApplicationControlTargetProcessType.CERTIFICATE:
      return translateFn('Certificate');
  }
}
export function getTargetProcessTypeFormOptionsForDropdown(): Array<SelectOption> {
  return [
    {
      title: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.PATH),
      value: ApplicationControlTargetProcessType.PATH,
    },
    {
      title: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.HASH),
      value: ApplicationControlTargetProcessType.HASH,
    },
    {
      title: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.CERTIFICATE),
      value: ApplicationControlTargetProcessType.CERTIFICATE,
    },
  ];
}
export function getTargetTypeFormOptionsForGrid(): Array<IColumnOption> {
  return [
    {
      label: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.PATH),
      value: ApplicationControlTargetProcessType.PATH,
    },
    {
      label: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.HASH),
      value: ApplicationControlTargetProcessType.HASH,
    },
    {
      label: getTargetProcessTypeLabel(ApplicationControlTargetProcessType.CERTIFICATE),
      value: ApplicationControlTargetProcessType.CERTIFICATE,
    },
  ];
}

// Target context section
export function getTargetContextFormOptions(): Array<EnumListItem | IColumnOption> {
  return [
    {
      label: translateFn('Local disk'),
      value: ApplicationControlTargetContext.LOCAL,
    },
    {
      label: translateFn('CD-ROM'),
      value: ApplicationControlTargetContext.CDROM,
    },
    {
      label: translateFn('Removable drive'),
      value: ApplicationControlTargetContext.REMOVABLE,
    },
    {
      label: translateFn('Network share'),
      value: ApplicationControlTargetContext.NETWORK,
    },
  ];
}
